export default function PageLoadingOverlay({
  loading,
  message = "Loading...",
  fullScreen = false,
}) {
  if (!loading) return null;

  return (
    <div
      className={`page-loading-overlay ${fullScreen ? "full-screen" : ""}`}
      aria-live="polite"
      aria-busy="true"
    >
      <div className="page-loading-card">
        <div className="page-loading-spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
}
